import React from 'react';

//  Interfaces
import { TableHead, Item } from '@components/UI-KIT/Table';

// Components
import AmountFormat from '@components/utils/AmountFormat';
import DniFormat from '@components/utils/DniFormat';
import Typography from '@components/UI-KIT/Typography';

const formatValue = (value: string, format: string) => {
    switch (format) {
        case 'amount':
            return (
                <AmountFormat
                    value={value}
                />
            );
        case 'date':
            return value.split('-').reverse().join('/');
        case 'dni':
            return (
                <DniFormat
                    value={value}
                />
            );
        default:
            return value;
    }
};

export const handleTableContent: (_item: Item, _head: TableHead) => string | number | JSX.Element = (item: Item, head: TableHead) => {
    let result: any;
    switch (head.type) {
        case 'composed':
            if (!head.fields) throw new Error('You have to declare item fields in composed typed table heads');
            result = head.fields.map((field: string) => item[field]).join(head.valuesSeparator);
            break;
        case 'nested':
            result = item;
            if (!head.fields) throw new Error('You have to declare item fields in nested typed table heads');
            head.fields.forEach(field => result = result[field]);
            break;
        case 'quantity':
            if (!head.field) throw new Error('You have to declare item field in quantity typed table heads');
            result = item[head.field].length;
            break;
        case 'custom':
            if (!head.handleValue) throw new Error('You have to declare an action handler in custom typed table heads');
            result = head.handleValue(item);
            break;
        default:
            if (!head.field) throw new Error('You have to declare item field in default table heads');
            result = item[head.field];
            break;
    }

    if (result && head.format === 'date') result = formatValue(result, 'date');
    if (result && head.format === 'amount') result = formatValue(result, 'amount');
    if (result && head.format === 'dni') result = formatValue(result, 'dni');

    return !result
        ? '-'
        : typeof result === 'string'
            ? (
                <Typography
                    variant="table-regular"
                    color="primary-dark"
                >
                    {result}
                </Typography>
            ) : result;
};
